import React from 'react';
import { Link } from 'react-router-dom';
import SiteFooter from '../SiteFooter';
import './LegalPages.css';

/**
 * Shared shell for privacy policy and terms of service (public, unauthenticated).
 */
const LegalDocumentLayout = ({ title, children }) => {
  return (
    <div className="legal-page">
      <header className="legal-page__header">
        <Link to="/login" className="legal-page__brand">
          Back to School Forms
        </Link>
        <nav className="legal-page__nav" aria-label="Legal">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-of-service">Terms of Service</Link>
        </nav>
      </header>
      <main className="legal-page__main">
        <article className="legal-document">
          <h1>{title}</h1>
          {children}
        </article>
      </main>
      <SiteFooter />
    </div>
  );
};

export default LegalDocumentLayout;
